import React from 'react';
import PropTypes from 'prop-types';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Box } from '../../../components';
import FormField from '../fields/FormField';

const propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object),
  previewMode: PropTypes.bool,
};

const defaultProps = {
  fields: undefined,
  previewMode: false,
};

function EditFormFields({ fields, previewMode }) {
  let defaultName = '';
  if (previewMode) {
    defaultName = 'Name not linked yet';
  }
  const fieldOptions = (fields || []).map((field, index) => (
    <Draggable
      key={field.id}
      draggableId={`EditFormFields-${field.id}`}
      index={index}
    >
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <FormField
            edit={!previewMode}
            id={field.id}
            name={field.name || defaultName}
            type={field.uiComponent}
          />
          <Box height="0.5em" />
        </div>
      )}
    </Draggable>
  ));

  const emptyMessage = 'This form has no elements, drags some in to start creating your form!';

  return (
    <Droppable droppableId="EditFormFields">
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {fields && fields.length === 0 ? emptyMessage : fieldOptions}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}
EditFormFields.propTypes = propTypes;
EditFormFields.defaultProps = defaultProps;
export default EditFormFields;
